import React, { useState } from "react";
import { InputForm, SelectInputForm, TextAreaForm } from "../atoms/input";
import { StandardButton } from "../atoms/buttons";

export function ExtraConfigPanel({setExtraData, extraData, handleSave}){
  const handleChange = (key) => (value) => {
    setExtraData((prev) => ({ ...prev, [key]: value }));
  }
  const inputFields = [
    {
      id: 1,
      key: "goal",
      title: "Leerdoel",
      placeholder: "Wat voor soort leerinhoud wil je genereren?",
      Component: InputForm,
    },
    {
    id: 2,
    key: "format",
    title: "Contentformaat",
    placeholder: "Wat wil je genereren?",
    Component: SelectInputForm,
    options: (
      <>
        <option value="">-- Kies type content --</option>
        <option value="uitleg">Uitleg / theorie</option>
        <option value="instructie">Stapsgewijze instructie</option>
        <option value="voorbeeld">Praktijkvoorbeeld / casus</option>
        <option value="samenvatting">Samenvatting</option>
        <option value="tiplijst">Tips / do's & don'ts</option>
        <option value="reflectie">Reflectievraag</option>
      </>
    )
  },
    {
      id: 3,
      key: "keywords",
      title: "Belangrijke trefwoorden",
      placeholder: "Bijv. leiderschap, soft skills, feedbackcultuur",
      Component: InputForm,
    },
    {
      id: 4,
      key: "notes",
      title: "Extra opmerkingen of instructies",
      placeholder: "Bijv. beperk lengte tot 150 woorden of gebruik bullet points",
      Component: TextAreaForm,
    },
  ];

  return (
    <div className="standard-small-margin-top">
      <p className="standard-margin-bottom standard-text-color-light">
        Stel je AI-configuratie hier in.
      </p>
      {inputFields.map(({ id, title, placeholder, Component, key, options }) => (
        <Component
          key={id}
          id={id}
          title={title}
          placeholder={placeholder}
          value={extraData[key]}
          typeInput={handleChange(key)}
          onChange={handleChange(key)}
          options={options}
        />
      ))}
    </div>
  );
}
